// import external dependencies

jQuery( document ).ready(function($){
  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
     if (scroll >= 200) {
      $('body').addClass('scrolling');
  } else {
    $('body').removeClass('scrolling');
  }
}); //missing );
  $('.parallax-window').parallax();
  if ( $( '.carousel' ).length ) {

        $('.carousel').slick({
            dots: true,
            arrows: false,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 4,
            autoplay: true,
            autoplaySpeed: 6000,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
              {
                breakpoint: 480,
                settings: 'unslick',
                
              },
            ],
          });
        }
})



// WEBPACK FOOTER //
// ./scripts/main.js